import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class ArrowConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'stem_length',
			'stem_width',
			'head_length',
			'head_width',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions(): Record<string, Length> {
		return {
		};
	}

	get_labels(): Record<string, string> {
		const { stem_height, stem_width, head_height, head_width } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			stem_height,
			stem_width,
			head_height,
			head_width,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			stem_length: [ MaximumDecimalPoints, MinimumValue ],
			stem_width: [ MaximumDecimalPoints, MinimumValue ],
			head_length: [ MaximumDecimalPoints, MinimumValue ],
			head_width: [ MaximumDecimalPoints, MinimumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'complex';
	}
}
